import NotificationContext from './NotificationContext.jsx';

export {NotificationContext}



// WEBPACK FOOTER //
// ./components/UI/Notification/index.js